import React, { Component } from 'react';
import Header from './../components/Header';
import PdfViewer from './../components/PdfViewer';

class CompanyListPage extends Component {
  render() {
    return (
      <div>
        <Header />
        <PdfViewer />
      </div>
    );
  }
}

export default CompanyListPage;
